import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-set";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-finite";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.match";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { email, required, sameAs, minLength } from 'vuelidate/lib/validators'
// import { email, sameAs, required, between, maxLength, minLength, numeric } from 'vuelidate/lib/validators'
import { email, sameAs, required, minLength, maxLength } from 'vuelidate/lib/validators'; // import { email, required } from 'vuelidate/lib/validators'

import { showErrorMessage } from 'src/functions/my-functions';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { createHomeDenseIcon } from 'src/components/map/homeDenseIcon';

var pjson = require("../../package.json"); // const placeDummy = require('../assets/placeDummyGieten.json')


var minPasswordLength = 8;
var BIAS_RADIUS_DEG = 1; // ~110 km soft bias window

var AUTOCOMPLETE_FIELDS = ['geometry', 'formatted_address', 'address_components', 'name', 'place_id'];
export default {
  name: 'RegisterEditAccount',
  components: {
    LMap: LMap,
    LTileLayer: LTileLayer,
    LMarker: LMarker
  },
  // props: {
  //     updateMode: {
  //         type: Boolean,
  //         default: false
  //     }
  // },
  props: {
    updateMode: Boolean,
    communityId: String,
    tags: Array,
    externalId: String,
    externalType: String
  },
  // props: ['updateMode', 'communityId', 'tags'],
  data: function data() {
    return {
      debugMode: false,
      data: {
        name: undefined,
        city: undefined,
        centerCoordinates: undefined,
        email: undefined,
        password: undefined,
        repeatPassword: undefined,
        agreeDisclaimer: false,
        // education: undefined,
        age: undefined,
        gender: undefined,
        place: undefined
      },
      searchQuery: undefined,
      locationSource: null,
      // searchOutput: undefined,
      loading: false,
      geolocateLoading: false,
      autocomplete: null,
      biasBounds: null,
      minPasswordLength: minPasswordLength,
      minNameLength: 3,
      maxNameLength: 20,
      homeMarkerIcon: createHomeDenseIcon(),
      contentStyle: {
        backgroundColor: 'rgba(0,0,0,0.02)',
        color: '#555'
      },
      contentActiveStyle: {
        backgroundColor: '#eee',
        color: 'black'
      },
      thumbStyle: {
        right: '2px',
        borderRadius: '5px',
        backgroundColor: '#027be3',
        width: '5px',
        opacity: 0.75
      },
      eduOptions: ['Less than highschool', 'High school graduate', 'Some college,no degree', 'Associates degree', 'Bachelors degree', 'Masters degree', 'Professional school degree', 'Doctorate degree'],
      ageOptions: this.calcAges(),
      genderOptions: ['male', 'female', 'other'],
      isPwd: true
    };
  },
  methods: {
    // setPlaceDummy () {
    //     this.data.place = placeDummy
    // },
    clearSearch: function clearSearch() {
      var _this = this;

      this.data.place = null;
      this.searchQuery = undefined;
      this.locationSource = null;
      this.$nextTick(function () {
        _this.initAddressAutocomplete();
      });
    },
    placeCoord: function placeCoord(value) {
      return typeof value === 'function' ? value() : value;
    },
    onHomePreviewMapReady: function onHomePreviewMapReady(map) {
      this.$nextTick(function () {
        if (map && map.invalidateSize) {
          map.invalidateSize();
        }
      });
    },
    normalizeSearchQuery: function normalizeSearchQuery() {
      if (!this.searchQuery) return;
      var trimmed = String(this.searchQuery).trim();
      var match = trimmed.match(/^(\d{4})\s*([A-Za-z]{2})$/);
      if (!match) return;
      var next = match[1] + ' ' + match[2].toUpperCase();

      if (next !== this.searchQuery) {
        this.searchQuery = next;
      }
    },
    applyBias: function applyBias(lat, lng) {
      if (!window.google || !window.google.maps || lat == null || lng == null) return;
      this.biasBounds = new window.google.maps.LatLngBounds({
        lat: lat - BIAS_RADIUS_DEG,
        lng: lng - BIAS_RADIUS_DEG
      }, {
        lat: lat + BIAS_RADIUS_DEG,
        lng: lng + BIAS_RADIUS_DEG
      });

      if (this.autocomplete) {
        this.autocomplete.setBounds(this.biasBounds);
      }
    },
    getCurrentPositionPromise: function getCurrentPositionPromise(options) {
      return new Promise(function (resolve, reject) {
        if (!navigator.geolocation) {
          reject(new Error('unsupported'));
          return;
        }

        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
    },
    resolveBiasFromIp: function resolveBiasFromIp() {
      return fetch('https://get.geojs.io/v1/ip/geo.json').then(function (res) {
        return res.json();
      }).then(function (geo) {
        var lat = parseFloat(geo.latitude);
        var lng = parseFloat(geo.longitude);

        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          return {
            lat: lat,
            lng: lng
          };
        }

        return null;
      }).catch(function () {
        return null;
      });
    },
    resolveSearchBias: function () {
      var _resolveSearchBias = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var status, pos, ip;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(navigator.permissions && navigator.permissions.query)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 4;
                return navigator.permissions.query({
                  name: 'geolocation'
                });

              case 4:
                status = _context.sent;

                if (!(status.state === 'granted')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return this.getCurrentPositionPromise({
                  enableHighAccuracy: false,
                  timeout: 2000,
                  maximumAge: 600000
                });

              case 8:
                pos = _context.sent;
                this.applyBias(pos.coords.latitude, pos.coords.longitude);
                return _context.abrupt("return");

              case 11:
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

              case 15:
                _context.next = 17;
                return this.resolveBiasFromIp();

              case 17:
                ip = _context.sent;

                if (ip) {
                  this.applyBias(ip.lat, ip.lng);
                }

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function resolveSearchBias() {
        return _resolveSearchBias.apply(this, arguments);
      }

      return resolveSearchBias;
    }(),
    setPlaceFromResult: function setPlaceFromResult(place, source) {
      if (!place || !place.geometry || !place.geometry.location) {
        return false;
      }

      Vue.set(this.data, 'place', place);
      this.locationSource = source || null;
      return true;
    },
    geocodeAddress: function geocodeAddress(address) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (!address || !window.google || !window.google.maps) {
          resolve(null);
          return;
        }

        var geocoder = new window.google.maps.Geocoder();
        var request = {
          address: address
        };

        if (_this2.biasBounds) {
          request.bounds = _this2.biasBounds;
        }

        geocoder.geocode(request, function (results, status) {
          if (status === 'OK' && results && results[0]) {
            resolve(results[0]);
          } else {
            resolve(null);
          }
        });
      });
    },
    geocodeLatLng: function geocodeLatLng(lat, lng) {
      return new Promise(function (resolve) {
        if (!window.google || !window.google.maps) {
          resolve(null);
          return;
        }

        var geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
          location: {
            lat: lat,
            lng: lng
          }
        }, function (results, status) {
          if (status === 'OK' && results && results[0]) {
            resolve(results[0]);
          } else {
            resolve(null);
          }
        });
      });
    },
    onAddressEnter: function () {
      var _onAddressEnter = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var query, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.data.place || this.geolocateLoading)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.normalizeSearchQuery();
                query = (this.searchQuery || '').trim();

                if (query) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                _context2.next = 8;
                return this.geocodeAddress(query);

              case 8:
                result = _context2.sent;

                if (!this.setPlaceFromResult(result, 'google_geocode_fallback')) {
                  this.$q.notify({
                    message: this.$t('pages.register.location_not_found'),
                    color: 'negative',
                    icon: 'place'
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onAddressEnter() {
        return _onAddressEnter.apply(this, arguments);
      }

      return onAddressEnter;
    }(),
    useMyLocation: function () {
      var _useMyLocation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var pos, _lat, _lng, result;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.geolocateLoading) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this.geolocateLoading = true;
                _context3.prev = 3;
                _context3.next = 6;
                return this.getCurrentPositionPromise({
                  enableHighAccuracy: true,
                  timeout: 10000,
                  maximumAge: 0
                });

              case 6:
                pos = _context3.sent;
                _lat = pos.coords.latitude;
                _lng = pos.coords.longitude;
                this.applyBias(_lat, _lng);
                _context3.next = 12;
                return this.geocodeLatLng(_lat, _lng);

              case 12:
                result = _context3.sent;

                if (!this.setPlaceFromResult(result, 'geolocate')) {
                  // Still usable as approximate home if reverse geocode fails
                  Vue.set(this.data, 'place', {
                    formatted_address: _lat.toFixed(5) + ', ' + _lng.toFixed(5),
                    geometry: {
                      location: {
                        lat: function lat() {
                          return _lat;
                        },
                        lng: function lng() {
                          return _lng;
                        }
                      }
                    }
                  });
                  this.locationSource = 'geolocate';
                }

                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](3);
                this.$q.notify({
                  message: this.$t('pages.register.geolocate_failed'),
                  color: 'negative',
                  icon: 'my_location'
                });

              case 19:
                _context3.prev = 19;
                this.geolocateLoading = false;
                return _context3.finish(19);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 16, 19, 22]]);
      }));

      function useMyLocation() {
        return _useMyLocation.apply(this, arguments);
      }

      return useMyLocation;
    }(),
    initAddressAutocomplete: function initAddressAutocomplete() {
      var _this3 = this;

      var input = document.getElementById('address');

      if (!input || !window.google || !window.google.maps || !window.google.maps.places) {
        return;
      }

      if (this.autocomplete && window.google.maps.event) {
        window.google.maps.event.clearInstanceListeners(this.autocomplete);
      } // Drop orphaned Google dropdowns left behind by re-inits


      document.querySelectorAll('.pac-container').forEach(function (el) {
        return el.remove();
      });
      var options = {
        types: ['geocode'],
        fields: AUTOCOMPLETE_FIELDS,
        strictBounds: false
      };

      if (this.biasBounds) {
        options.bounds = this.biasBounds;
      }

      this.autocomplete = new window.google.maps.places.Autocomplete(input, options); // Google defaults to "Enter a location"; keep our floating label instead

      input.setAttribute('placeholder', ' ');
      this.autocomplete.addListener('place_changed', function () {
        var place = _this3.autocomplete.getPlace();

        if (!_this3.setPlaceFromResult(place, 'google_autocomplete') && _this3.searchQuery) {
          _this3.onAddressEnter();
        }
      });
      this.bindPacAlignment();
    },
    getAddressFieldControl: function getAddressFieldControl() {
      var field = this.$refs.autocomplete && this.$refs.autocomplete.$el;
      if (!field) return null;
      return field.querySelector('.q-field__control') || field;
    },
    ensureCountryNameIndex: function ensureCountryNameIndex() {
      if (this._countryNameIndex) return this._countryNameIndex;
      var index = Object.create(null); // Skip withdrawn / exceptional ISO codes that share DisplayNames with live ones
      // (e.g. FX→France, DD→Germany) so flagcdn gets FR/DE not FX/DD.

      var obsolete = {
        an: 1,
        bu: 1,
        cs: 1,
        dd: 1,
        dy: 1,
        fx: 1,
        hv: 1,
        nh: 1,
        rh: 1,
        su: 1,
        tp: 1,
        uk: 1,
        vd: 1,
        yd: 1,
        yu: 1,
        zr: 1
      };

      if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
        ;
        ['en', 'nl', 'de', 'fr'].forEach(function (locale) {
          var displayNames;

          try {
            displayNames = new Intl.DisplayNames([locale], {
              type: 'region'
            });
          } catch (e) {
            return;
          }

          for (var a = 65; a <= 90; a++) {
            for (var b = 65; b <= 90; b++) {
              var code = String.fromCharCode(a) + String.fromCharCode(b);
              var lower = code.toLowerCase();
              if (obsolete[lower]) continue;
              var name = displayNames.of(code);
              if (!name || name === code) continue;
              index[name.toLowerCase()] = lower;
            }
          }
        });
      }

      var aliases = {
        uk: 'gb',
        usa: 'us',
        'u.s.': 'us',
        'u.s.a.': 'us',
        'united states of america': 'us',
        'the netherlands': 'nl',
        'kingdom of the netherlands': 'nl',
        'great britain': 'gb',
        england: 'gb',
        scotland: 'gb',
        wales: 'gb',
        'northern ireland': 'gb',
        'ivory coast': 'ci',
        "cote d'ivoire": 'ci',
        'côte d’ivoire': 'ci',
        "côte d'ivoire": 'ci'
      };
      Object.keys(aliases).forEach(function (key) {
        index[key] = aliases[key];
      });
      this._countryNameIndex = index;
      return index;
    },
    countryCodeFromName: function countryCodeFromName(name) {
      if (!name) return '';
      var needle = String(name).trim().toLowerCase();
      if (!needle) return '';
      return this.ensureCountryNameIndex()[needle] || '';
    },
    countryCodeFromPacItem: function countryCodeFromPacItem(item) {
      if (!item) return '';
      var text = (item.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return '';
      var parts = text.split(',').map(function (part) {
        return part.trim();
      }).filter(Boolean);

      for (var i = parts.length - 1; i >= 0; i--) {
        var code = this.countryCodeFromName(parts[i]);
        if (code) return code;
      } // Secondary span only (e.g. " Netherlands")


      var spans = item.querySelectorAll('span:not(.pac-icon):not(.pac-item-query):not(.pac-matched)');

      for (var _i = spans.length - 1; _i >= 0; _i--) {
        var _code = this.countryCodeFromName(spans[_i].textContent);

        if (_code) return _code;
      }

      return '';
    },
    decoratePacFlags: function decoratePacFlags() {
      var _this4 = this;

      document.querySelectorAll('.pac-container .pac-item').forEach(function (item) {
        // Stacked country line: drop Google's leading ", " so it isn't ", Netherlands".
        item.querySelectorAll('span:not(.pac-icon):not(.pac-item-query):not(.pac-matched)').forEach(function (span) {
          var raw = span.textContent || '';
          if (!/^[\s,]/.test(raw)) return;
          var cleaned = raw.replace(/^[\s,]+/, '').trim();
          if (cleaned) span.textContent = cleaned;
        });
        var icon = item.querySelector('.pac-icon');
        if (!icon) return;

        var code = _this4.countryCodeFromPacItem(item);

        var mark = code || '0';
        if (item.dataset.xenaFlag === mark) return;
        item.dataset.xenaFlag = mark;
        if (!code || !/^[a-z]{2}$/.test(code)) return;
        icon.classList.add('pac-icon--flag');
        icon.classList.remove('pac-icon-marker');
        icon.style.backgroundImage = 'none';
        icon.innerHTML = '';
        var img = document.createElement('img');
        img.className = 'pac-flag';
        img.alt = '';
        img.width = 20;
        img.height = 15;
        img.src = 'https://flagcdn.com/w40/' + code + '.png';
        img.srcset = 'https://flagcdn.com/w80/' + code + '.png 2x';

        img.onerror = function () {
          img.classList.add('pac-flag--empty');
          img.removeAttribute('src');
          img.removeAttribute('srcset');
        };

        icon.appendChild(img);
      });
    },
    alignPacContainer: function alignPacContainer() {
      var _this5 = this;

      if (this._aligningPac) return;
      var control = this.getAddressFieldControl();
      if (!control) return;
      var pacs = document.querySelectorAll('.pac-container');
      if (!pacs.length) return;
      var rect = control.getBoundingClientRect(); // Fixed coords so Quasar prepend/scroll/modals don't offset Google's absolute placement

      var left = Math.round(rect.left) + 'px';
      var top = Math.round(rect.bottom + 4) + 'px';
      var width = Math.round(rect.width) + 'px';
      this._aligningPac = true;
      pacs.forEach(function (pac) {
        pac.style.setProperty('position', 'fixed', 'important');
        pac.style.setProperty('left', left, 'important');
        pac.style.setProperty('top', top, 'important');
        pac.style.setProperty('width', width, 'important');
        pac.style.setProperty('right', 'auto', 'important');
        pac.style.setProperty('margin-top', '0', 'important');
      });
      this.decoratePacFlags();
      this.$nextTick(function () {
        _this5._aligningPac = false;
      });
    },
    schedulePacAlignment: function schedulePacAlignment() {
      var _this6 = this;

      this.alignPacContainer();
      window.requestAnimationFrame(function () {
        return _this6.alignPacContainer();
      });
      clearTimeout(this._pacAlignTimer); // Google often positions while still display:none, then shows — re-apply after that

      this._pacAlignTimer = setTimeout(function () {
        return _this6.alignPacContainer();
      }, 80);
    },
    bindPacAlignment: function bindPacAlignment() {
      var _this7 = this;

      this.unbindPacAlignment();
      var input = document.getElementById('address');
      if (!input) return;

      this._alignPac = function () {
        return _this7.schedulePacAlignment();
      };

      input.addEventListener('input', this._alignPac);
      input.addEventListener('keydown', this._alignPac);
      input.addEventListener('focus', this._alignPac);
      window.addEventListener('resize', this._alignPac);
      window.addEventListener('scroll', this._alignPac, true);
      this._pacBodyObserver = new MutationObserver(function () {
        document.querySelectorAll('.pac-container').forEach(function (pac) {
          if (_this7._pacObserved && _this7._pacObserved.has(pac)) return;
          if (!_this7._pacObserved) _this7._pacObserved = new WeakSet();

          _this7._pacObserved.add(pac);

          if (!_this7._pacStyleObserver) {
            _this7._pacStyleObserver = new MutationObserver(function () {
              if (!_this7._aligningPac) {
                _this7.decoratePacFlags();

                _this7.schedulePacAlignment();
              }
            });
          }

          _this7._pacStyleObserver.observe(pac, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['style', 'class']
          });
        });

        _this7.decoratePacFlags();

        _this7.schedulePacAlignment();
      });

      this._pacBodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },
    unbindPacAlignment: function unbindPacAlignment() {
      var input = document.getElementById('address');

      if (input && this._alignPac) {
        input.removeEventListener('input', this._alignPac);
        input.removeEventListener('keydown', this._alignPac);
        input.removeEventListener('focus', this._alignPac);
      }

      if (this._alignPac) {
        window.removeEventListener('resize', this._alignPac);
        window.removeEventListener('scroll', this._alignPac, true);
      }

      if (this._pacBodyObserver) {
        this._pacBodyObserver.disconnect();

        this._pacBodyObserver = null;
      }

      if (this._pacStyleObserver) {
        this._pacStyleObserver.disconnect();

        this._pacStyleObserver = null;
      }

      clearTimeout(this._pacAlignTimer);
      this._pacAlignTimer = null;
      this._pacObserved = null;
      this._alignPac = null;
      this._aligningPac = false;
    },
    calcAges: function calcAges() {
      var ages = [];

      for (var i = 1; i * 5 + 5 <= 100; i++) {
        ages.push(i * 5 + 1 + '-' + (i * 5 + 5));
      }

      ages.shift();
      ages.shift();
      return ages;
    },
    onClickBack: function onClickBack() {
      location.reload();
    },
    register: function register() {
      var _this8 = this;

      // console.log('REGISSTER')
      this.$v.data.$touch(); // console.log(this.$v.data.$error)
      // console.log(this.$v.data)

      if (!this.$v.data.$error) {
        this.loading = true;
        this.$q.loading.show({
          delay: 400 // ms

        });
        var temp = JSON.parse(JSON.stringify(this.data));
        temp.place['searchQuery'] = this.searchQuery;
        delete temp.password;
        delete temp.repeatPassword;
        var centerCoordinates = []; // console.log(this.data.place.geometry.location.lng())
        // console.log(this.data.place.geometry.location.lat())

        centerCoordinates.push(this.data.place.geometry.location.lng());
        centerCoordinates.push(this.data.place.geometry.location.lat()); // console.log('centerCoordinates', centerCoordinates)

        temp.centerCoordinates = centerCoordinates;
        temp.locationSource = this.locationSource; // console.log('temp.centerCoordinates', temp.centerCoordinates)
        // console.log('this.data.place', this.data.place)
        // console.log('this.data.place.vicinity', this.data.place.vicinity)
        // if (this.data.place.vicinity) {
        //     temp.city = JSON.parse(JSON.stringify(this.data.place.vicinity))
        // }
        // if (this.data.place.formatted_address) {
        //     temp.formatted_address = JSON.parse(JSON.stringify(this.data.place.formatted_address))
        // }

        temp.score = 0;
        temp.locale = this.$i18n.locale; // CreateAreaPage v2 — tags users registered via the current welcome/register flow

        temp.flow = '2.0';
        temp.analitics = {
          device: window.device,
          platform: this.$q.platform,
          appVersion: pjson.version,
          pazzword: this.data.password
        };
        temp.subs = [];

        if (this.communityId) {
          temp.subs.push(this.communityId);
        }

        if (this.tags) {
          // console.log('tags', this.tags)
          this.tags.forEach(function (tag) {
            var test = _this8.landByTag(tag); // console.log('tets', test)


            temp.subs.push(test.id);
          });
          temp.tags = this.tags;
        }

        if (this.externalId) {
          temp.externalId = this.externalId;
          temp.externalType = this.externalType;
          console.log('ext_id_REG', temp.externalId + ' : ' + temp.externalType);
        } // console.log('-----------DATA-----------------', temp)


        this.$meteor.accounts.createUser({
          email: this.data.email.toLowerCase(),
          password: this.data.password,
          // profile: {
          //     name: this.data.name
          // }
          profile: temp
        }, function (err, res) {
          if (err) {
            _this8.loading = false;

            _this8.$q.loading.hide();

            showErrorMessage(err.reason);
          } else {
            _this8.$q.loading.hide();

            _this8.loading = false;

            _this8.$q.notify({
              message: _this8.$t('messages.account_created'),
              color: 'positive'
            });

            var tagsToCheck = ['kosterpolis', 'kosterfunding', 'bornholmpolis', 'bornholmfunding'];
            var tags = temp.tags;
            var atLeastOneTag = tags && tagsToCheck.some(function (tag) {
              return tags.includes(tag);
            });

            if (atLeastOneTag) {
              var land = _this8.landByTag(tags[0]);

              var tag = land.tags.find(function (t) {
                return t.id === tags[0];
              });

              _this8.$router.push({
                path: tag.url
              });
            } else {
              _this8.$router.push({
                name: 'createMaatregel',
                params: {
                  mode: 'regular'
                }
              });
            }
          }
        });
      } else {
        this.loading = false;
        this.$q.loading.hide(); // this.$q.notify({
        //     color: 'negative',
        //     position: 'top',
        //     message: 'De combinatie van postcode en huisnummer is onjuist',
        //     icon: 'report_problem'
        // })
      }
    },
    update: function update() {
      var _this9 = this;

      console.log('-------------------update called--------------------------');
      this.$v.data.$touch(); // console.log(this.$v.data.$error)
      // console.log(this.$v.data)

      if (!this.$v.data.$error) {
        this.loading = true; // let temp = JSON.parse(JSON.stringify(this.data))

        var name = this.data.name;
        var temp = JSON.parse(JSON.stringify({
          name: name
        }));

        var _email = this.data.email.toLowerCase();

        this.$meteor.call('user.update', temp, _email, function (err) {
          if (err) {
            showErrorMessage(err.reason); // this.$q.notify({
            //     message: err.reason,
            //     color: 'negative'
            // })

            _this9.loading = false;
          } else {
            // BUG: throws error and does not show message
            // this.$q.notify({
            //     message: this.$t('messages.account_updated'),
            //     color: 'positive'
            // })
            _this9.loading = false;
          }
        });
      }
    }
  },
  validations: function validations() {
    var rules = {
      data: {
        name: {
          required: required,
          minLength: minLength(this.minNameLength),
          maxLength: maxLength(this.maxNameLength)
        },
        // city: { required },
        // number: { required },
        password: {
          required: required,
          minLength: minLength(minPasswordLength)
        },
        repeatPassword: {
          sameAsPassword: sameAs('password')
        },
        email: {
          required: required,
          email: email
        },
        place: {
          required: required
        },
        // zipcode: {
        //     required,
        //     minLength: minLength(6)
        // },
        agreeDisclaimer: {
          checked: function checked(value) {
            return value === true;
          }
        },
        // education: { required },
        age: {
          required: required
        },
        gender: {
          required: required
        }
      }
    };

    if (this.updateMode) {
      // delete rules.data.number
      delete rules.data.password;
      delete rules.data.repeatPassword; // delete rules.data.zipcode

      delete rules.data.agreeDisclaimer;
      delete rules.data.place; // delete rules.data.education

      delete rules.data.age;
      delete rules.data.gender;
    }

    return rules;
  },
  created: function created() {
    // console.log('Created')
    // console.log(this.$meteor.user())
    if (this.updateMode) {
      // console.log(this.$meteor.user().emails[0].address)
      // console.log(this.$meteor.user())
      var profile = this.$meteor.user().profile;
      this.data.name = profile.name; // this.data.number = profile.number

      this.data.zipcode = profile.zipcode;
      this.data.email = this.$meteor.user().emails[0].address; // console.log(this.$meteor.user().emails[0].address)
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    if (this.externalId) {
      this.data.email = this.externalId;
    }

    if (this.debugMode) {
      var random = Math.floor(Math.random() * 10000);
      this.data.email = 'test' + random + '@test.nl';
      this.data.name = 'displayName' + random;
      this.data.age = this.CageOptions[0];
      this.data.gender = this.genderOptions[0];
      this.data.password = '11111111';
      this.data.repeatPassword = '11111111';
      this.data.agreeDisclaimer = true;
    } // console.log(this.tags)


    if (!this.updateMode) {
      this.resolveSearchBias().finally(function () {
        _this10.initAddressAutocomplete();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindPacAlignment();
  },

  /*    watch: {
          user: {
              immediate: true,
              handler (val) {
                  console.log('user', this.user)
                  if (this.user) {
                      if (this.communityId || this.tags) {
                          this.$router.push({ name: 'introduction' })
                      } else {
                          if (this.user.profile.owner) {
                              this.$router.push({ name: 'myCommunities' })
                          } else if (this.user.profile.subs.length > 0) {
                              this.$router.push({ name: 'myCommunities' })
                          } else if (this.measuresMine.length > 0) {
                              this.$router.push({ name: 'myAreas' })
                          } else {
                              /!* if(this.communityId){
                           } *!/
                               this.$router.push({ name: 'introduction' })
                          }
                      }
                  }
              }
          }
      }, */
  computed: _objectSpread({}, mapGetters(['user', 'measuresMine', 'landByTag']), {
    layout: function layout() {
      return this.$q.screen.lt.sm || this.$q.screen.lt.md;
    },
    homeMapCenter: function homeMapCenter() {
      var location = this.data.place && this.data.place.geometry && this.data.place.geometry.location;

      if (!location) {
        return null;
      }

      var lat = this.placeCoord(location.lat);
      var lng = this.placeCoord(location.lng);

      if (lat == null || lng == null) {
        return null;
      }

      return [lat, lng];
    }
  })
};